// frontend/components/Common/LoadingSpinner.jsx
import React from 'react';

export default function LoadingSpinner({ size = 'md', fullScreen = false, text = 'Loading...' }) {
    const sizes = {
        sm: 'h-8 w-8',
        md: 'h-12 w-12',
        lg: 'h-16 w-16',
        xl: 'h-24 w-24'
    };

    const spinner = (
        <div className="flex flex-col items-center justify-center">
            <div className={`animate-spin rounded-full border-b-2 border-blue-600 ${sizes[size]}`}></div>
            {text && <p className="mt-4 text-gray-600">{text}</p>}
        </div>
    );

    if (fullScreen) {
        return (
            <div className="fixed inset-0 bg-white bg-opacity-90 flex items-center justify-center z-50">
                {spinner}
            </div>
        );
    }

    return spinner;
}